import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { LayoutDashboard, Home, User, Award, Brain } from 'lucide-react';

import { fireDB as db, appId } from '../../services/firebase'; // 서비스 경로
import { LAW_DATA } from '../../data/laws'; // 데이터 경로

export default function Dashboard({ user, userData, setView }) {
  const [stats, setStats] = useState({ odaptongCount: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      const wrongRef = collection(db, 'artifacts', appId, 'users', user.uid, 'wrong_answers');
      const snap = await getDocs(wrongRef);
      let count = 0;
      snap.forEach(doc => {
        if ((doc.data().count >= 3 || doc.data().isBookmarked) && doc.data().count !== 0) count++;
      });
      setStats({ odaptongCount: count });
    };
    fetchStats();
  }, [user]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-white flex items-center">
          <LayoutDashboard className="mr-2 text-indigo-400" /> 대시보드
        </h2>
        <button onClick={() => setView('home')} className="bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg font-bold">
          <Home className="w-4 h-4 mr-2" /> 메인으로 돌아가기
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-slate-800 p-6 rounded-xl shadow-lg border border-slate-700">
          <h3 className="text-lg font-bold text-slate-200 mb-2 flex items-center">
            <User className="w-5 h-5 mr-2 text-indigo-400" /> 내 정보
          </h3>
          <p className="text-2xl font-bold text-white">{userData.name}</p>
          <div className="mt-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-slate-400">진행률</span>
              <span className="font-medium text-indigo-300">{Math.round((userData.progress || 0) / LAW_DATA.length * 100)}%</span>
            </div>
            <div className="w-full bg-slate-700 rounded-full h-2.5 overflow-hidden">
              <div className="bg-gradient-to-r from-indigo-500 to-purple-500 h-2.5 rounded-full" style={{ width: `${Math.round((userData.progress || 0) / LAW_DATA.length * 100)}%` }}></div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-indigo-900 to-purple-900 p-6 rounded-xl shadow-lg text-white border border-indigo-700/50">
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <Award className="w-5 h-5 mr-2 text-yellow-300" /> 학습 상태
          </h3>
          <div className="grid grid-cols-2 gap-4 text-center">
            <div className="bg-black/20 rounded-lg p-2">
              <p className="text-3xl font-bold">{userData.loginCount || 0}</p>
              <p className="text-xs opacity-70">출석일수</p>
            </div>
            <div className="bg-black/20 rounded-lg p-2">
              <p className="text-3xl font-bold">{stats.odaptongCount}</p>
              <p className="text-xs opacity-70">오답통 문제</p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <button onClick={() => setView('odaptong')} className="bg-slate-800 hover:bg-slate-750 border-2 border-orange-500/50 hover:border-orange-500 p-6 rounded-xl shadow-lg flex items-center justify-between transition group hover:bg-orange-950/20">
          <div className="flex items-center">
            <div className="bg-orange-900/50 p-4 rounded-full mr-4 group-hover:scale-110 transition border border-orange-700/50">
              <Brain className="w-8 h-8 text-orange-500" />
            </div>
            <div className="text-left">
              <h3 className="font-bold text-lg text-white">오답통 학습하기</h3>
              <p className="text-sm text-slate-400">3번 이상 틀리거나 체크한 조문 집중 공략</p>
            </div>
          </div>
          {stats.odaptongCount > 0 ? <span className="bg-red-500 text-white font-bold text-sm px-4 py-1 rounded-full shadow-lg animate-pulse">{stats.odaptongCount}개</span> : <span className="bg-slate-700 text-slate-400 font-bold text-sm px-4 py-1 rounded-full">비어있음</span>}
        </button>
      </div>
    </div>
  );
}